import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import "./index.scss";

export const BreadCrumbs = ({ children }) => (
  <div className="breadcrumbs">{children}</div>
);

export const Crumbs = ({ text, to }) => (
  <>
    <NavLink className="crumb" to={to}>
      {text}
    </NavLink>
    <span className="icon-chevron-right" />
  </>
);

export const ActiveCrumbs = ({ text }) => (
  <p className="crumb -active">{text}</p>
);

BreadCrumbs.propTypes = {
  children: PropTypes.node.isRequired,
};

Crumbs.propTypes = {
  to: PropTypes.string,
  text: PropTypes.string.isRequired,
};

ActiveCrumbs.propTypes = {
  text: PropTypes.string.isRequired,
};

Crumbs.defaultProps = {
  to: null,
};
